import * as _ from "underscore";

export function isNullOrUndefined(obj: any) {
  return _.isNull(obj) || _.isUndefined(obj);
}
